import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';

// ES6 class-style
class PageBanner extends PreLoginSessionCheck {
  render() {
  	return(
  		<section className={this.props.classes}>
		 	<div className="container"> 
		 	 	<h1>{this.props.name} <span>{this.props.text}</span></h1>   
		 	</div> 
		</section>
  	);
  }
}

export default PageBanner;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/PageBanner.js